import styles from './style.module.scss';
import { Col, Divider, Row, Spin, Table, Typography } from 'antd';
import useConsumiNetSales from '../useConsumiNetSales';
import UIHelper from '../../../../../helpers/UIHelper';
import BarChangeChart from '../../../charts/barChange';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    columns,
    columns2,
    format,
    title,
    loading,
    summary,
    summary2,
    searchParams,
    filters,
  } = useConsumiNetSales(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>
                  Sales by Category / Sales
                </Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <Table
                    loading={loading}
                    columns={UIHelper.assignTire(columns)}
                    dataSource={data.table1}
                    pagination={{
                      pageSize: 10000,
                      position: ['bottomCenter'],
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                    }}
                    bordered
                    summary={summary}
                    scroll={{}}
                  />
                </Col>
                <Divider />
                <Col span={24} className={'chartColl'}>
                  <Table
                    loading={loading}
                    columns={UIHelper.assignTire(columns2)}
                    dataSource={data.table2}
                    pagination={{
                      pageSize: 10000,
                      position: ['bottomCenter'],
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                    }}
                    bordered
                    summary={summary2}
                    scroll={{}}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={14} className={'chartColl'}>
              <BarChangeChart
                keys={['Inc. % Net Sales YTD', 'Inc. % Net Sales LY']}
                data={data}
                format={format}
                lineItemWidth={180}
                itemWidth={200}
                translateX={280}
              />

              <br />
              <BarChangeChart
                keys={['Inc. % Net Sales YTD', 'Inc. % Net Sales LY']}
                data={data.bar2}
                format={format}
                lineItemWidth={180}
                itemWidth={200}
                translateX={280}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Print;
